import * as React from 'react';
import { SideBar } from './SideBar';
import TopBar from './TopBar';
import { LogManager } from '../utils/LogManager';
import { ServiceUnavailableEnhancerProperties, withServiceUnavailable } from './hocs/ServiceUnavailableEnhancer';
import { createDomainApi } from '../utils/createApi';
import { LoaderIcon } from './common/Icons';
import { WebserviceAvailabilityChecker, WebserviceStatus } from '../services/WebserviceAvailabilityChecker';
import { withLoader } from './hocs/LoaderEnhancer';
import { WebportalEvent } from '../services/WebportalEvent';

const logManager = new LogManager('Webportal');

const unhandledRejectionHandler = (e: any) => {
    logManager.error(JSON.stringify(e));
};

class MainContainer extends React.Component<ServiceUnavailableEnhancerProperties, any> {
    render(): JSX.Element | null {
        return (
            <div className="main__container">
                <TopBar />
                {this.props.children}
            </div>
        );
    }
}
const MainContainerWithServiceUnavailable = withLoader(
    withServiceUnavailable(MainContainer) as any,
    'mainContainer'
) as any;

interface WebportalProperties {
    experimentalSettingsEnabled: string[];
}

interface WebportalState {
    webserviceIsUnavailable: boolean;
    isCheckingAvailability: boolean;
}

export default class Webportal extends React.Component<WebportalProperties, WebportalState> {
    private availabilityChecker: WebserviceAvailabilityChecker;

    constructor(props: any) {
        super(props);

        this.handleWebserviceStatusChange = this.handleWebserviceStatusChange.bind(this);
        Webportal.checkWebserviceIsAvailable = Webportal.checkWebserviceIsAvailable.bind(this);

        this.availabilityChecker = new WebserviceAvailabilityChecker(
            WebportalEvent.GatewayProblem,
            Webportal.checkWebserviceIsAvailable,
            this.handleWebserviceStatusChange
        );

        this.state = {
            webserviceIsUnavailable: false,
            isCheckingAvailability: false
        };
    }

    componentDidMount() {
        this.availabilityChecker.registerListeners();
        window.addEventListener('error', unhandledRejectionHandler);
    }

    componentWillUnmount() {
        this.availabilityChecker.unregisterListeners();
        window.removeEventListener('error', unhandledRejectionHandler);
    }

    render() {
        const loader = (
            <div id="global-loader">
                <LoaderIcon width="100px" />
            </div>
        );

        return (
            <React.Fragment>
                <div className="page d-flex flex-md-row flex-column">
                    <SideBar/>
                    {loader}
                    <MainContainerWithServiceUnavailable loading={this.state.isCheckingAvailability} serviceUnavailable={this.state.webserviceIsUnavailable}>
                        {this.props.children}
                    </MainContainerWithServiceUnavailable>
                </div>
            </React.Fragment>
        );
    }

    private static async checkWebserviceIsAvailable(): Promise<boolean> {
        const domainApi = await createDomainApi();
        try {
            await domainApi.getDomains();
        } catch (e) {
            if (e.response && e.response.statusCode < 500) {
                return true;
            }

            logManager.log('Webservice ping unsuccessfull.');
            logManager.error(e);
            return false;
        }
        return true;
    }

    private async handleWebserviceStatusChange(currentStatus: WebserviceStatus): Promise<void> {
        switch (currentStatus) {
            case WebserviceStatus.Available:
                this.setState({ webserviceIsUnavailable: false, isCheckingAvailability: false });
                break;
            case WebserviceStatus.Verifying:
                this.setState({ isCheckingAvailability: true });
                break;
            default:
            case WebserviceStatus.Unavailable:
                this.setState({ webserviceIsUnavailable: true, isCheckingAvailability: false });
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/webportal/components/Webportal.tsx